import React, {useState, useEffect} from 'react';
import {Header, Titulo} from '../elementos/Header'
import { Helmet, HelmetProvider } from 'react-helmet-async'
import withRouter from './withRouter';
import Api from '../servicios/api'
import BtnRegresar from '../elementos/BtnRegresar'
import FormularioTipoPublicacion from './FormularioTipoPublicacion'
import favicon from '../imagenes/logoutm.png'
import Cargando from '../elementos/Cargando'

const EditarTipoPublicacion = (props) => {
    const [datosCargados, setdatosCargados] = useState(false);
    const [tipopublicacion, setTipoPublicacion] = useState([]);

    //Este hook se ejecuta solamente al primer renderizado
    useEffect(() => {
        fetch(Api+"?consultarTipoPublicacionID="+props.params.id)
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            setdatosCargados(true);
            setTipoPublicacion(datosRespuesta[0]);
        })
        .catch(console.log)
    }, [props]);

    if(!datosCargados){
        return(
            <Cargando />
        );
    }
    else{
        return (
            <>
                <HelmetProvider>
                    <div>
                        <Helmet>
                            <link rel="shortcut icon" href={favicon} type="image/x-con"/>
                            <title>Actualizar Tipo de Publicación</title>
                        </Helmet>
                    </div>
                </HelmetProvider>

                <Header>
                        <Titulo>Actualizar Tipo de Publicación</Titulo>
                        <BtnRegresar ruta="/tipo-publicaciones"/>
                </Header>

                <FormularioTipoPublicacion tipopublicacion={tipopublicacion}/>
            </>
        );
    }
}
 
export default withRouter(EditarTipoPublicacion);